/* liftsets (BUILD-xxxii): "Notify me" on sold-out product cards. Finds every product card whose badge
   reads "Sold out", adds a button that reveals a one-field email form posting through Shopify's contact
   endpoint (form_type=contact) with the product handle, title and URL as contact fields, tagged
   "back-in-stock". No app, no third-party script; Shopify redirects back to the page with
   ?contact_posted=true, which shows the confirmation. Progressive enhancement: without JS the card
   still links to the product page. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ls-notify-root]');
  if (!root) return;
  var soldOutText = (root.getAttribute('data-ls-soldout') || 'Sold out').trim().toLowerCase();
  var labels = {
    button: root.getAttribute('data-ls-btn') || 'Notify me when back in stock',
    submit: root.getAttribute('data-ls-submit') || 'Notify me',
    placeholder: root.getAttribute('data-ls-placeholder') || 'Email address',
    privacy: root.getAttribute('data-ls-privacy') || '',
    done: root.getAttribute('data-ls-done') || 'Thanks, we will email you when it is back.'
  };
  var pageTitle = root.getAttribute('data-ls-page') || document.title;

  function uid() { return 'n' + Math.random().toString(36).slice(2, 8); }

  function build(card, link) {
    var handle = (link.getAttribute('href') || '').split('?')[0].split('#')[0].split('/products/')[1] || '';
    var title = (card.querySelector('.card__heading') || link).textContent.trim();
    var wrap = document.createElement('div');
    wrap.className = 'ls-notify-card';
    var id = uid();
    wrap.innerHTML =
      '<button type="button" class="ls-notify-card__btn" aria-expanded="false" aria-controls="' + id + '">' + labels.button + '</button>' +
      '<form class="ls-notify-card__form" id="' + id + '" method="post" action="/contact#ls-notify" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="back-in-stock">' +
        '<input type="hidden" name="contact[Subject]" value="Back in stock request">' +
        '<input type="hidden" name="contact[Product]" value="">' +
        '<input type="hidden" name="contact[Product handle]" value="">' +
        '<input type="hidden" name="contact[Product URL]" value="">' +
        '<input type="hidden" name="contact[Page]" value="">' +
        '<input type="hidden" name="contact[body]" value="">' +
        '<label class="visually-hidden" for="' + id + '-email">' + labels.placeholder + '</label>' +
        '<input type="email" id="' + id + '-email" name="contact[email]" required autocomplete="email" placeholder="' + labels.placeholder + '">' +
        '<button type="submit" class="button">' + labels.submit + '</button>' +
        (labels.privacy ? '<p class="ls-notify-card__privacy">' + labels.privacy + '</p>' : '') +
      '</form>';
    wrap.querySelector('[name="contact[Product]"]').value = title;
    wrap.querySelector('[name="contact[Product handle]"]').value = handle;
    wrap.querySelector('[name="contact[Product URL]"]').value = location.origin + '/products/' + handle;
    wrap.querySelector('[name="contact[Page]"]').value = pageTitle;
    wrap.querySelector('[name="contact[body]"]').value = 'Please email me when "' + title + '" (' + handle + ') is back in stock.';
    var btn = wrap.querySelector('.ls-notify-card__btn');
    var form = wrap.querySelector('form');
    btn.addEventListener('click', function () {
      var open = form.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) form.querySelector('input[type=email]').focus();
    });
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem('ls-notify-pending', title); } catch (e) { /* private mode */ }
    });
    var info = card.querySelector('.card__information') || card.querySelector('.card__content') || card;
    info.appendChild(wrap);
  }

  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    if (card.querySelector('.ls-notify-card')) return;
    var badge = Array.prototype.find.call(card.querySelectorAll('.badge'), function (b) { return b.textContent.trim().toLowerCase() === soldOutText; });
    if (!badge) return;
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    build(card, link);
  });

  if (/[?&]contact_posted=true/.test(location.search)) {
    var pending = '';
    try { pending = sessionStorage.getItem('ls-notify-pending') || ''; sessionStorage.removeItem('ls-notify-pending'); } catch (e) { /* ignore */ }
    if (pending) {
      var toast = document.createElement('p');
      toast.className = 'ls-notify-toast';
      toast.setAttribute('role', 'status');
      toast.textContent = labels.done + ' (' + pending + ')';
      root.appendChild(toast);
      toast.setAttribute('tabindex', '-1');
      toast.focus();
    }
  }
})();
